export default __webpack_public_path__ + "static/media/Segoe-mdl2-assets.7a8bfdc6.ttf";